import Menu from 'ui/Menu';

import { useSankeyFormContext } from '../../../contexts/sankeyFormContext';
import { useCurrentUser } from '../../../utils/user';
import ActionMenuTriggerButton from '../ActionMenuTriggerButton';
import BrowseTemplatesMenuItem from './BrowseTemplatesMenuItem';
import CopyDiagramMenuItem from './CopyDiagramMenuItem';
import DeleteDiagramMenuItem from './DeleteDiagramMenuItem';
import DownloadDiagramMenuItem from './DownloadDiagramMenuItem';
import NewDiagramMenuItem from './NewDiagramMenuItem';
import OpenDiagramMenuItem from './OpenDiagramMenuItem';
import RedoMenuItem from './RedoMenuItem';
import ShareDiagramMenuItem from './ShareDiagramMenuItem';
import SmartImportMenuItem from './SmartImportMenuItem';
import UndoMenuItem from './UndoMenuItem';

const FileMenu: React.FC = () => {
  const { user } = useCurrentUser();
  const { isErrorFetching, isFetching } = useSankeyFormContext();

  return (
    <Menu.Root>
      <Menu.Trigger>
        <ActionMenuTriggerButton disabled={isErrorFetching || isFetching}>
          File
        </ActionMenuTriggerButton>
      </Menu.Trigger>
      <Menu.Content>
        <UndoMenuItem />
        <RedoMenuItem />
        <Menu.Separator />
        <NewDiagramMenuItem />
        <CopyDiagramMenuItem />
        <SmartImportMenuItem />
        {user?.is_authenticated && <OpenDiagramMenuItem />}
        {!user?.is_authenticated && <BrowseTemplatesMenuItem />}
        <ShareDiagramMenuItem />
        <DownloadDiagramMenuItem />
        {user?.can_delete_sankeys && (
          <>
            <Menu.Separator />
            <DeleteDiagramMenuItem />
          </>
        )}
      </Menu.Content>
    </Menu.Root>
  );
};

export default FileMenu;
